import * as React from "react";
import {connect, ConnectedProps} from "react-redux";
import {useState} from "react";
import {IPartner, PartnerSideEnum} from "@leap4/entities-discrepancy-common";
import {AlertTypes, apiClient, enumNamesToSelect, Grid, setAlert, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, TextField, LoadingButton} from "@leap4/frontend";
import {QueryObserverResult, RefetchOptions, RefetchQueryFilters, useQuery} from "react-query";
import {partnersBaseUrl} from "../../../../config/generals";
import {RootState} from "../../../../interfaces/root-state.interface";

type PropsForNewPartner = {
    side: string,
    openCreatePartner: boolean,
    setOpenDialog: (boolean) => void
    setOpenCreatePartner: (boolean) => void
    getAssignPartners: <TPageData>(options?: (RefetchOptions & RefetchQueryFilters<TPageData>)) => Promise<QueryObserverResult<void, any>>
};

interface IFormData extends Partial<IPartner> {
}

const mapStateToProps = (state: RootState) => ({
    selectedOrganization: state.auth.selectedOrganizationId
});

const connector = connect(mapStateToProps);

const _CreateNewPartnerDialog = (props: PropsForNewPartner) => {
    const [entity, setInstance] = useState<IFormData>({});
    const {side, openCreatePartner, setOpenDialog, setOpenCreatePartner, getAssignPartners} = props
    const PartnerSideSelect = enumNamesToSelect(PartnerSideEnum, undefined, undefined, 'Side')

    const handleCancelDialog = () => {
        setOpenDialog(false);
        setOpenCreatePartner(false);
    };

    const handleFormChange = (e: any) => {
        let {name, value} = e.target;
        setInstance({...entity, [name]: value});
    }

    const onSavePartner = async () => {
        if (!entity) {
            return false;
        }
        entity.side = (side === "demand" ? PartnerSideEnum.DEMAND : PartnerSideEnum.SUPPLY)
        await apiClient.post(partnersBaseUrl, entity)
        setOpenDialog(true);
        setOpenCreatePartner(false);
        return getAssignPartners()
    };

    const {isLoading: isLoadingSave, refetch: refetchSave} = useQuery(
        'save-partner--query',
        onSavePartner,
        {
            refetchOnWindowFocus: false,
            cacheTime: 0,
            enabled: false,
            onError: (err: any) => setAlert({msg: err.message, type: AlertTypes.FAILURE})
        });


    return <Dialog open={openCreatePartner} onClose={handleCancelDialog}>
        <DialogTitle>Create partner</DialogTitle>
        <DialogContent>
            <DialogContentText>
                {`Create partner`}

            </DialogContentText>
            {isLoadingSave ? <Grid item xs={12}></Grid> :
                <div>
                    <Grid item xs={12}>
                        <TextField
                            disabled={isLoadingSave}
                            variant="outlined"
                            margin="normal"
                            required
                            fullWidth
                            label="Name"
                            name="name"
                            autoComplete="name"
                            autoFocus
                            onChange={handleFormChange}
                            value={entity?.name}
                        />
                    </Grid>
                    <Grid item xs={20}>
                        <FormControl variant="outlined">
                            <PartnerSideSelect
                                label={'Side'}
                                required
                                fullWidth
                                disabled={true}
                                value={side}
                                onChange={handleFormChange}
                                name="side"/>
                        </FormControl>
                    </Grid>
                </div>
            }
        </DialogContent>
        <DialogActions>
            <LoadingButton onClick={handleCancelDialog} loading={isLoadingSave}> Cancel</LoadingButton>
            <LoadingButton onClick={() => refetchSave()} loading={isLoadingSave}>Save</LoadingButton>
        </DialogActions>
    </Dialog>
}

export const CreateNewPartnerDialog = connector(_CreateNewPartnerDialog)